import { ReactElement } from "react";
import { PersonAvatar } from "client/Components";
import { getContactPhotoUrl } from "client/Features/AddressBook/common";
import { localize } from "client_legacy/ndaw/culture";
import styles from "./OrganizerDetail.module.less";

type OrganizerDetailProps = {
	displayName: string;
	emailAddress: string;
};

export const OrganizerDetail = (props: OrganizerDetailProps): ReactElement => {
	const {
		displayName,
		emailAddress
	} = props;

	return (
		<div className={styles.root}>
			<div className={styles.avatar}>
				<PersonAvatar
					initials={displayName.length > 0 ? displayName[0] : ""}
					imageSrc={getContactPhotoUrl(emailAddress)}
				/>
			</div>
			<div className={styles.content}>
				{`${displayName} (${localize("_Organiser")})`}
			</div>
		</div>
	);
};
OrganizerDetail.displayName="OrganizerDetail";